import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import InputRichText from 'components/Inputs/inputRichText';
import Button from 'components/Buttons/Button';
import { useCounter } from 'utils/customHooks';
import { stripTags } from 'utils/functions';
import { useSelector } from 'react-redux';
import Panel from 'components/Panel';
import PanelHeader from 'components/Panel/components/PanelHeader';
import { deleteNote, getNote, postNote } from './actions';

function Note({ type, id }) {
  const literalsCommon = useSelector(state => state.i18n.literals.common);

  const forceUpdate = useCounter(0);
  const [loading, setLoading] = useState(false);
  const [note, setNote] = useState({
    loaded: false,
    existPrev: false,
    note: '',
  });

  useEffect(() => {
    (async () => {
      const prevNote = await getNote(type, id);
      setNote({
        loaded: true,
        existPrev: !!prevNote?.id,
        note: prevNote?.note || '',
      });
      forceUpdate.increase();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePostNote = async () => {
    setLoading(true);
    await postNote(type, id, note.note);
    setNote(prev => ({ ...prev, existPrev: true }));
    setLoading(false);
    forceUpdate.increase();
  };

  const handleDeleteNote = async () => {
    setLoading(true);
    await deleteNote(type, id);
    setNote(prev => ({ ...prev, note: '', existPrev: false }));
    setLoading(false);
    forceUpdate.increase();
  };

  return (
    <Panel>
      <PanelHeader title={literalsCommon.notes} subtitle={literalsCommon.notesSubtitle} />
      <InputRichText
        key={`note.${type}.${id}.${forceUpdate.value}`}
        value={note.note}
        onChange={v => setNote(prev => ({ ...prev, note: v }))}
        isDisabled={!note.loaded}
      />
      <div className='buttons-left'>
        <Button
          text={literalsCommon.save}
          onClick={handlePostNote}
          loading={loading}
          disabled={!stripTags(note.note).trim()}
        />
        {note.existPrev && (
          <Button
            text={literalsCommon.delete}
            color='outline-danger'
            onClick={handleDeleteNote}
            loading={loading}
          />
        )}
      </div>
    </Panel>
  );
}

Note.propTypes = {
  type: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};

export default Note;
